import React from 'react';
import { connect } from 'react-redux';

import { APP_NAME, STATIC_ROOT } from '../../constants';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import './Logo.scss';

const Logo = ({ i18n, className }) => (
    <div id="logo">
        <div>
            <img
                src={`${STATIC_ROOT}/logo.png`}
                alt={APP_NAME}
                className={className}
                height={45}
                width={151}
            />
        </div>
        <span>{convertHtmlToReactDomWithParams(i18n.LOGO_TEXT_INSTANT_DISCOUNT)}</span>
    </div>
);

const mapStateToProps = state => ({
    i18n: state.i18n.feature.header
});

export default connect(mapStateToProps)(Logo);



// WEBPACK FOOTER //
// ./src/components/icons/Logo.js